import { Box } from "@mui/system";
import React from "react";
import { useFormContext } from "react-hook-form";
import { CompactFieldRow } from "../../../form/compactFieldRow";
import { FormTextField } from "../../../form/textfield";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { FormSelect } from "../../../form/select";
import { FormSwitch } from "../../../form/switch";
import { Button, Typography } from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";

const FormBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export default function UserInfoForm() {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <FormBox>
        <CompactFieldRow
          firstchildren={
            <FormTextField
              name="first_name"
              control={control}
              label={t("First Name")}
              mandatory={true}
            />
          }
          secondchildren={
            <FormTextField
              name="last_name"
              control={control}
              label={t("Last Name")}
              mandatory={true}
            />
          }
        />
        <CompactFieldRow
          firstchildren={
            <FormTextField
              name="company"
              control={control}
              label={t("Organisation")}
            />
          }
          secondchildren={
            <FormTextField
              name="position"
              control={control}
              label={t("Position")}
            />
          }
        />
        <CompactFieldRow
          firstchildren={
            <FormTextField name="phone" control={control} label={t("Phone")} type="tel"/>
          }
          secondchildren={
            <FormTextField
              name="email"
              control={control}
              label={t("E-mail")}
              type="email"
              uneditable={false}
              mandatory={true}
            />
          }
        />
        <CompactFieldRow
          firstchildren={
            <FormSwitch name="active" control={control} label={t("Active")} />
          }
          secondchildren={
            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                width: "100%",
                alignItems: "flex-end",
                height: "40px",
                marginRight: "30px",
                marginBottom: "10px",
              }}
            ></Box>
          }
        />
      </FormBox>
    </>
  );
}
